import { Component, OnInit } from '@angular/core';
import { InquiryService } from '../../../services/inquiry.service';
import { Inquiry } from '../../../models/inquiry.model';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../../material.module';
import { Router, RouterModule } from '@angular/router';
import { ColDef, ColGroupDef } from 'ag-grid-community';
import { AgGridModule } from 'ag-grid-angular';
import { formatDate } from '../../../misc/functions';
import { FormsModule } from '@angular/forms';
import { ModalSnackbarService } from '../../../services/modal-snackbar.service';
import { LabelChipRendererComponent } from '../../label-chip/label-chip-renderer.componemt';
import { AG_GRID_LOCALE_JP } from '../../../misc/ag-grid-locale';

@Component({
  selector: 'app-inquiry-list',
  standalone: true,
  imports: [CommonModule, MaterialModule, RouterModule, AgGridModule, FormsModule, LabelChipRendererComponent],
  templateUrl: './inquiry-list.component.html',
  styleUrls: ['./inquiry-list.component.scss']
})
export class InquiryListComponent implements OnInit {

  localeText = AG_GRID_LOCALE_JP;

  columnDefs: (ColDef | ColGroupDef)[] = [
    { field: 'created_at', headerName: '作成日時', width: 165, valueFormatter: params => formatDate(params.value)},
    { field: 'title', headerName: 'タイトル', flex: 1},
    { field: 'status', headerName: '状態', width: 110,  cellRenderer: LabelChipRendererComponent, cellStyle: { 'text-align': 'center' }}, // , filter: 'agTextColumnFilter', sortable: true
  ];

  paginationPageSizeSelector: number[] | boolean = [10, 20, 50, 100];

  showCompleted = false; // デフォルトは「完了は非表示」

  allRows: Inquiry[] = []; // APIレスポンスを保持
  rowData: Inquiry[] = []; // 表示用データ

  constructor(
    private service: InquiryService,
    private snackBar: ModalSnackbarService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.load();
  }

  applyFilter(): void {
    if (this.showCompleted) {
      this.rowData = this.allRows;
    } else {
      this.rowData = this.allRows.filter(row => row.status !== '完了');
    }
  }

  onToggleCompleted(): void {
    this.applyFilter();
  }

  load(): void {
    this.service.getAll('お問い合わせ').subscribe({
      next: (res) => {
        this.allRows = res;
        this.applyFilter();
      },
      error: () => this.snackBar.show('お問い合わせ一覧の取得に失敗しました')
    });
  }

  onRowClicked(event: any): void {
    const id = event.data.id;
    this.router.navigate(['/inquiry', id]);
  }
}
